import { useEffect } from 'react';
import type { ReactNode } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { onPermissionsChanged } from '../api';
import ErrorScreen from '../core-components/theme/components/ErrorScreen';
import { LoadingState } from '../core-components/theme/components/Screen/ScreenStates';

import { accessKeys } from './query-keys';
import { meAccessQueryOptions } from './queryOptions';

export const AccessProvider = ({ children }: { children: ReactNode }) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { data, isError, refetch } = useQuery(meAccessQueryOptions());

  useEffect(() => onPermissionsChanged(() => void queryClient.invalidateQueries({ queryKey: accessKeys.all })), [queryClient]);

  if (data !== undefined) return <>{children}</>;
  if (isError) return <ErrorScreen onRetry={() => void refetch()} />;
  return <LoadingState label={t('access.loading', 'Loading your access')} />;
};
